export const getConfirmModalProps = ({
  isApp,
  totalAiScoutMessageCounts,
  textAreaValue,
  lastTextIsAiCreated,
  handlers,
  visibility,
}: {
  isApp: boolean;
  totalAiScoutMessageCounts: number;
  textAreaValue: string;
  lastTextIsAiCreated: boolean;
  handlers: {
    handleClickCloseAiCreateConfirmModal: () => void;
    handleClickAiCreateTrigger: () => void;
    handleClickTransitionToPurchaseOption: () => void;
    handleClickCloseOverwriteTextAreaConfirmModal: () => void;
    handleClickOverwriteTextAreaTrigger: () => void;
    handleClickCloseReloadModal: () => void;
    handleClickReloadTrigger: () => void;
    handleClickCloseRefetchModal: () => void;
    handleClickRefetchTrigger: () => void;
  };
  visibility: {
    isShowAiCreateConfirmModal: boolean;
    isShowOverwriteTextAreaConfirmModal: boolean;
    isShowReloadModal: boolean;
    isShowRefetchModal: boolean;
  };
}) => {
  const {
    handleClickCloseAiCreateConfirmModal,
    handleClickAiCreateTrigger,
    handleClickTransitionToPurchaseOption,
    handleClickCloseOverwriteTextAreaConfirmModal,
    handleClickOverwriteTextAreaTrigger,
    handleClickCloseReloadModal,
    handleClickReloadTrigger,
    handleClickCloseRefetchModal,
    handleClickRefetchTrigger,
  } = handlers;

  const {
    isShowAiCreateConfirmModal,
    isShowOverwriteTextAreaConfirmModal,
    isShowReloadModal,
    isShowRefetchModal,
  } = visibility;

  let confirmButtonText = "";
  if (totalAiScoutMessageCounts) {
    confirmButtonText = "実行する";
  } else if (!isApp) {
    confirmButtonText = "購入画面へ進む";
  }

  return {
    aiCreateConfirmModalProps: {
      isShow: isShowAiCreateConfirmModal,
      title: totalAiScoutMessageCounts
        ? "作成した時点でAIスカウトメッセージの\n使用可能回数が減ります。実行しますか？"
        : "AIスカウトメッセージの使用可能回数がありません。",
      description: totalAiScoutMessageCounts
        ? `使用可能回数： 残り${totalAiScoutMessageCounts}回`
        : "オプションで追加購入しますか？",
      notation:
        textAreaValue && totalAiScoutMessageCounts ? "※実行すると、入力した文章が消えます。" : "",
      confirmButtonText,
      onCancel: handleClickCloseAiCreateConfirmModal,
      onConfirm: totalAiScoutMessageCounts
        ? handleClickAiCreateTrigger
        : handleClickTransitionToPurchaseOption,
    },
    overwriteTextAreaConfirmModalProps: {
      isShow: isShowOverwriteTextAreaConfirmModal,
      title: "テンプレートを選択しますか？",
      description: lastTextIsAiCreated
        ? "テンプレートを選択すると、AIで作成したメッセージが消えます。"
        : "",
      confirmButtonText: "実行する",
      onCancel: handleClickCloseOverwriteTextAreaConfirmModal,
      onConfirm: handleClickOverwriteTextAreaTrigger,
    },
    reloadModalProps: {
      isShow: isShowReloadModal,
      title: "システムエラー",
      description: "メッセージの作成に失敗しました。\n再読み込みしてください。",
      confirmButtonText: "再読み込みする",
      onCancel: handleClickCloseReloadModal,
      onConfirm: handleClickReloadTrigger,
    },
    refetchModalProps: {
      isShow: isShowRefetchModal,
      title: "システムエラー",
      description: "メッセージの作成に失敗しました。\nもう一度試してください。",
      confirmButtonText: "再度試す",
      onCancel: handleClickCloseRefetchModal,
      onConfirm: handleClickRefetchTrigger,
    },
  };
};
